import React from 'react';

import styled from 'styled-components';

interface Props {
  companyLogo: React.ReactNode;
  children: React.ReactNode;
}

export function SPHeaderStructure({companyLogo, children}: Props): JSX.Element {
  return (
    <StyledHeader className="navbar navbar-expand bg-nav p-0 justify-content-between align-items-stretch">
      {companyLogo}
      <div className="d-flex flex-grow-1 align-items-stretch justify-content-end">
        {children}
      </div>
    </StyledHeader>
  );
}

const StyledHeader = styled.header`
  height: 70px;
  max-height: 200px;
`;
